import { apiPatch } from "../Api/apiCall";
import { getProductData } from "../Product/ProductService/productService";
import { getUpdateData } from "./persisterService";
import { persistAbstractCaseSubEntities } from "./AbstractCasePersister";
import { UseForm } from "../../types/UseForm";
import { FamilyLawCase } from "../../types/Products/FamilyLaw/FamilyLawCase";

export const persistFamilyLawCase = async (updateData: UseForm["values"], origFamilyLawCase: FamilyLawCase) => {
  await persistAbstractCaseSubEntities(updateData, origFamilyLawCase);

  const apiUri = getProductData(origFamilyLawCase.productClassName, "apiUri");
  const basicCaseUpdateData = getUpdateData(updateData, origFamilyLawCase);
  await apiPatch(apiUri, origFamilyLawCase.id, basicCaseUpdateData);
};
